import { Node, mergeAttributes } from '@tiptap/core'

export const Iframe = Node.create({
  name: 'iframe',

  group: 'block',

  selectable: false,

  addAttributes() {
    return {
      src: {
        default: null,
      },
    }
  },

  parseHTML: [{
      tag: 'iframe',
      getAttrs: node => {
        return {
          src: node.getAttribute('src')
        }
      }
  }],
  toHTML: node => ['div', { class: 'embed-responsive embed-responsive-16by9' } ,['iframe', { frameborder: 0, src: node.attrs.src, allowfullscreen: 'true' }]],

  renderHTML({ HTMLAttributes }) {
    return ['iframe', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ editor, node }) => {
      const div = document.createElement('div');
      div.className = 'aspect-w-16 aspect-h-9' + (editor.isEditable ? ' cursor-pointer' : '');
      const iframe = document.createElement('iframe');
      if (editor.isEditable) {
        iframe.className = 'pointer-events-none';
      }
      iframe.width = '200';
      iframe.height = '200';
      iframe.frameborder = "0";
      iframe.allowfullscreen = "";
      iframe.src = node.attrs.src;
      div.append(iframe);
      return {
        dom: div,
      }
    }
  }
  
})